import { campus } from './Campus';

const filters = [
    { id: 'all', title: 'All'},
    { id: 'race', title: 'Race'},
    { id: 'gender_bin', title: 'Gender'},
    { id: 'sexorientation', title: 'Sexual Orientation'},
    { id: 'religion', title: 'Religion'},
    { id: 'ideo', title: 'Political Ideology'},
    { id: 'major_group', title: 'Major'}
]

if (!campus) {
    // Insert 'University' immediately after 'All' so 'All' remains first/default
    filters.splice(1, 0, { id: 'university', title: 'University'});
}

export const demographics = filters;
